const toggleHidden = (className) => {
  const parentClass = className.length > 0 ? `.${className} ` : '';
  const elements = document.querySelectorAll(`${parentClass}.toggle-hidden`);

  if (elements.length > 1) {
    elements.forEach(element => { element.style.display = 'none'; });
    elements[0].style.display = 'block';
    var index = 0;

    window.setInterval(() => {
      index++;
      if (index >= elements.length) {
        index = 0;
      }

      elements.forEach((element, key) => {

        if (index === key) {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      });
    }, 3000);
  }
};

export default {
  init() {
    // Carousel nou start
    var carousel = $('#carousel'),
    threshold = 150,
    slideWidth = 500,
    dragStart, 
    dragEnd;

$('#next').click(function(){ shiftSlide(1) })
$('#prev').click(function(){ shiftSlide(-1) })


carousel.on('mousedown', function(){
  if (carousel.hasClass('transition')) return;
  dragStart = event.pageX;
  $(this).on('mousemove', function(){
    dragEnd = event.pageX;
    $(this).css('transform','translateX('+ dragPos() +'px)')
  })
  $(document).on('mouseup', function(){
    if (dragPos() > threshold) { return shiftSlide(1) }
    if (dragPos() < -threshold) { return shiftSlide(-1) }
    shiftSlide(0);
  })
});

function dragPos() {
  return dragEnd - dragStart;
}

function shiftSlide(direction) {
  if (carousel.hasClass('transition')) return;
  dragEnd = dragStart;
  $(document).off('mouseup')
  carousel.off('mousemove')
          .css('transform','translateX(' + (direction * slideWidth) + 'px)'); 
  setTimeout(function(){
    if (direction === 1) {
      $('.slide:first').before($('.slide:last'));
    } else if (direction === -1) {
      $('.slide:last').after($('.slide:first'));
    }
    carousel.removeClass('transition')
		carousel.css('transform','translateX(0px)'); 
  },200)
}
    //Carousel nou end

    // Toggle events every 3sec
    toggleHidden('card-latest-news');
    toggleHidden('card-latest-events');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js